<template>
  <div class="main-panel-container">
    <div
      class="cell cell-img van-hairline--bottom"
      @click="orderItemDetail(data.orderItems)"
    >
      <div class="img-list">
        <div
          v-for="(item, index) in data.orderItems"
          :key="data.orderNo + index"
          v-show="index < 3"
          class="img"
          :style="{
            backgroundImage: 'url(' + item.imgUrl + ')',
          }"
        ></div>
        <div
          class="more"
          v-show="data.orderItems && data.orderItems.length > 3"
        >
          …
        </div>
      </div>
      <div class="status">
        <span class="value">共{{ data.orderItemTotal }}件</span>
        <img :src="require('@/assets/setting/箭头.svg')" alt="" />
      </div>
    </div>
    <div class="cell cell-default van-hairline--bottom">
      <div class="label">退货原因</div>
      <div class="value">
        {{ data.appealReason }}
      </div>
    </div>
    <div class="cell cell-default van-hairline--bottom">
      <div class="label">退货描述</div>
      <div class="value">{{ data.description }}</div>
    </div>
    <div class="cell cell-affix">
      <div class="label">退单附件</div>
      <div class="img-list">
        <div
          class="img"
          :style="{
            backgroundImage: 'url(' + data.evidence + ')',
          }"
          @click="imagePreview(0, [data.evidence])"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { ImagePreview } from 'vant'
export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapState({
      returnOrderAppealReason: (state) => state.options.returnOrderAppealReason,
    }),
  },
  filters: {
    status_f(val, list) {
      const i = list.find((item) => item.value === val)
      return (i && i.label) || ''
    },
  },
  methods: {
    imagePreview(startPosition, list) {
      ImagePreview({
        images: list,
        startPosition,
      })
    },
    orderItemDetail(data) {

      this.$router.push({
        name: 'OrderAfterSaleGoodsDetail',
        query: { id: this.data.id, data: JSON.stringify(data) },
      })
    },
  },
}
</script>

<style lang="less" scoped>
.main-panel-container {
  background-color: #fff;
  box-shadow: 0px 8px 16px 0px rgba(152, 152, 152, 0.06);
  border-radius: 12px;
  padding: 0 0 0 32px;
  .cell {
    padding: 32px 32px 32px 0;
  }
  .cell-img {
    display: flex;
    justify-content: space-between;
    .img-list {
      display: flex;
      .img {
        width: 128px;
        height: 128px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 12px;
      }
    }
    .status {
      display: flex;
      font-size: 28px;
      line-height: 28px;
      align-items: center;
      span {
        font-size: 28px;
        line-height: 28px;
      }
      img {
        height: 23px;
        margin-left: 24px;
      }
    }
  }
  .cell-default {
    display: flex;
    justify-content: space-between;
    .label {
      font-size: 28px;
      line-height: 28px;
    }
    .value {
      font-size: 28px;
      color: #999999;
      line-height: 28px;
    }
  }
  .cell-affix {
    .label {
      font-size: 28px;
      line-height: 28px;
    }
    .img-list {
      display: flex;
      padding-top: 20px;
      .img {
        width: 144px;
        height: 144px;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center center;
        margin-right: 12px;
      }
    }
  }
}
</style>
